import { Button, Text } from '@billy/design-system'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Alignment } from '../types'
import * as Styled from './styles'

export type BulkActionsProps = {
  active?: boolean
  align?: Alignment
  onDeleteRow?: () => void
  onDone?: () => void
  onToggle: (active: boolean) => void
  selectedRows?: number
  selectedRowsText?: (selectedRows: number) => string
  totalRows: number
  totalRowsText: (totalRows: number) => string
  skipClosingOnDelete?: boolean
}

export const BulkActions = ({
  active,
  align = 'left',
  onDeleteRow = () => null,
  onDone = () => null,
  onToggle,
  selectedRows = 0,
  selectedRowsText,
  skipClosingOnDelete,
  totalRows,
  totalRowsText,
  ...rest
}: BulkActionsProps) => {
  const { t } = useTranslation()

  const handleDeleteRow = () => {
    onDeleteRow()

    if (!skipClosingOnDelete) {
      onToggle(false)
    }
  }

  const handleDone = () => {
    onDone()
    onToggle(false)
  }

  const selectedRowsTextComputed = selectedRowsText
    ? selectedRowsText(selectedRows)
    : t('components.infinitetable.selected_rows', { count: selectedRows })

  return (
    <Styled.BulkActionsWrapper align={align} {...rest}>
      {active ? (
        <>
          <Text>{selectedRowsTextComputed}</Text>
          <Styled.ButtonsWrapper>
            <Button color="danger" disabled={!selectedRows} onClick={handleDeleteRow} size="sm">
              {t('delete')}
            </Button>
            <Button onClick={handleDone} size="sm">
              {t('done')}
            </Button>
          </Styled.ButtonsWrapper>
        </>
      ) : (
        <>
          {totalRowsText && <Text>{totalRowsText(totalRows)}</Text>}
          <Styled.ButtonsWrapper>
            <Button onClick={() => onToggle(true)} size="sm">
              {t('edit')}
            </Button>
          </Styled.ButtonsWrapper>
        </>
      )}
    </Styled.BulkActionsWrapper>
  )
}
